// extracted by mini-css-extract-plugin
export default {"clickableLink":"document_clickableLink__I05Yw","disabled":"document_disabled__fwrWP"};